import React, { useContext, useEffect, useMemo } from "react";
//import { useDevices } from "../hooks/_useDevices";
import { useDevices } from "../hooks/useDevices";

export const DevicesContext = React.createContext();

export const DevicesProvider = ({ children }) => {
  const devicesState = useDevices();
  const value = useMemo(() => devicesState, [devicesState]);

  useEffect(() => {
    //console.log("DevicesProvider => ", value);
  }, [value]);

  return (
    <DevicesContext.Provider value={value}>{children}</DevicesContext.Provider>
  );
};

export function useDevicesContext() {
  return useContext(DevicesContext);
}
